import {ISharedModalBasic, ISharedModalBasicResponse} from '../../shared-models/modals/shared-modal-basic';
import {
  SharedModalBasicComponent,
} from '../../shared-components/components/shared-modal-basic/shared-modal-basic.component';
import {Injectable} from '@angular/core';
import {IModalDismissResult, ModalControllerService} from '../../shared-services/overlay/modal-controller.service';

@Injectable({
  providedIn: 'root',
})
export class SharedModalUtils {

  constructor(
    private modalController: ModalControllerService,
  ) {
  }

  async createModal(modalProps: ISharedModalBasic): Promise<IModalDismissResult> {
    const modalController = await this.modalController.create({
      component: SharedModalBasicComponent,
      componentProps: modalProps,
      cssClass: [...modalProps.cssClass ?? 'shared-basic-modal-css'],
      backdropDismiss: modalProps.backdropDismiss !== false,
    });
    await modalController.present();
    const returnValue: IModalDismissResult = await modalController.onDidDismiss();
    return returnValue;
  }

}
